import { combineReducers } from 'redux';
import {
  AddPartReducer,
  UpdatePartReducer,
  PartsSearchReducer,
  VendorSearchReducer,
  VehicleMakeSearchReducer,
  VehicleModelSearchReducer,
  ModelYearSearchReducer,
  AddItemReducer,
  UpdateSupplyReducer,
  SearchSupplyByNameReducer,
  SearchSupplyByVendorReducer,
  EstimateReducer,
  GetSingleEstimateReducer,
  deleteEstimateReducer,
  requestForChange,
  GetPartReducer,
  GetSupplyReducer,
} from './estimate-reducer';

const estimateRootReducer = combineReducers({
  addPart: AddPartReducer,
  updatedPart: UpdatePartReducer,
  addItem: AddItemReducer,
  updatedSupply: UpdateSupplyReducer,
  searchSupplyByName: SearchSupplyByNameReducer,
  searchSupplyByVendor: SearchSupplyByVendorReducer,
  partsState: PartsSearchReducer,
  partData: GetPartReducer,
  supplyData: GetSupplyReducer,
  vendorState: VendorSearchReducer,
  vehicleMakeState: VehicleMakeSearchReducer,
  vehicleModelState: VehicleModelSearchReducer,
  modelYearState: ModelYearSearchReducer,
  estimateData: EstimateReducer,
  deleteEstimate: deleteEstimateReducer,
  estimateById: GetSingleEstimateReducer,
  requestForChange: requestForChange,
});

export default estimateRootReducer;
